<template>
  <!--17张表-->
  <div id="myDnloadHomeTwoDetail">
    <nav class="allDl m_t_20 d_flex" id="topSerchDiv">
      <dl class="allDl_width25 allDl_span60" style="width: calc(100% - 50px)">
        <dd v-if="mySerchFist.key1DisplayName">
          <span>{{ mySerchFist.key1DisplayName }}:</span>
          <div>
            <allSelect
              v-model="pickleName"
              v-on:on-change="seltPickle($event, 1)"
              :chooseData="mySerchFist.key1List"
              :needReturn="'key1Name'"
              :matchValue="'key1Name'"
              :showValue="'{{key1Name}}'"
              :width="'100%'"
              :placeholder="'全部'"
              :borderLine="'#E5E5E5'"
            ></allSelect>
          </div>
        </dd>
        <dd v-if="mySerchFist.key2DisplayName && pickleName !== ''">
          <span>{{ mySerchFist.key2DisplayName }}:</span>
          <div>
            <allSelect
              v-on:on-change="seltPickle($event, 2)"
              v-model="storeName"
              :multiple="true"
              :chooseData="storeList"
              :needReturn="'id'"
              :matchValue="'name'"
              :showValue="'{{name}}'"
              :width="'100%'"
              :placeholder="'全部'"
              :borderLine="'#E5E5E5'"
            ></allSelect>
          </div>
        </dd>
        <dd :key="index" v-for="(item, index) in mySerchList" v-if="item.isMustFilter">
          <span>{{ item.displayColumnName }}:</span>
          <div>
            <allSelect
              v-if="item.fieldType !== 'Datetime'"
              v-model="item.valueData"
              :multiple="true"
              :chooseData="item.childList"
              :needReturn="'id'"
              :matchValue="'name'"
              :showValue="'{{name}}'"
              :width="'100%'"
              :placeholder="'全部'"
              :borderLine="'#E5E5E5'"
            ></allSelect>
            <div class="d_flex" v-if="item.fieldType === 'Datetime'">
              <div style="width: 45%">
                <cander v-model="item.startTime" :className="'allInput'" :newWidth="'100%'"></cander>
              </div>
              <div class="t_c" style="width: 40px">至</div>
              <div style="width: 45%">
                <cander
                  :minDate="item.startTime"
                  v-model="item.endTime"
                  :className="'allInput'"
                  :newWidth="'100%'"
                ></cander>
              </div>
            </div>
          </div>
        </dd>
        <dd v-if="IsHasUnit">
          <span>单位:</span>
          <div>
            <allSelect
              v-model="unitSelected"
              :chooseData="unitList"
              :multiple="false"
              :needReturn="'id'"
              :matchValue="'name'"
              :showValue="'{{name}}'"
              :width="'100%'"
              :placeholder="'全部'"
              :borderLine="'#E5E5E5'"
            ></allSelect>
          </div>
        </dd>
        <dt style="width: auto;" v-if="mySerchList.length > 0">
           <button  class="greenButton BtnMore"  @click="clkModel(1)">
              <span>更多搜索条件</span>
            </button>
          <button @click="confSerch()" class="suerButton">
            <i class="icon iconfont iconsousuo" style="font-size: 14px"></i>
            <span class="m_l_5">搜索</span>
          </button>
        </dt>
      </dl>
    </nav>
    <div>
      <div class="m_t_10 m_b_20">
        <!-- <div class="dis_line dnlDetDivTop" v-if="pickleName">
          <div class="suerButton dis_line c_p">
            <span>导出</span>
          </div>
          <div class="dnlDetDiv">
            <div>
              <button @click="allUpdow('excel')" :disabled="isBtn">excel</button>
            </div>
            <div>
              <button @click="allUpdow('csv')" :disabled="isBtn">csv</button>
            </div>
          </div>
        </div>
        <button v-if="pickleName" @click="seltGenre(2)" class="suerButton v_m m_l_10">
          <span>发送</span>
        </button>
        <button v-if="pickleName" @click="seltGenre(1)" class="suerButton v_m m_l_10">
          <span>订阅</span>
        </button> -->
        <span @click="$commonJs.backURL" class="btn-back">
          <span>返回</span>
        </span>
      </div>
       <div class="btn-group">
        <div class="group-lf"><span class="total">找到 {{ myList.totalCount }} 条数据</span>
        <span class="dnlDetDivTop" v-if="pickleName">
          <span class="btn-export" ></span>
           <div class="dnlDetDiv">
            <div>
              <button @click="allUpdow('excel')" :disabled="isBtn">excel</button>
            </div>
            <div>
              <button @click="allUpdow('csv')" :disabled="isBtn">csv</button>
            </div>
          </div>        </span>
        </div>
        <div class="group-rt">
          <span class="btn-notice" @click="clkModel(3)" v-if="mySerchData.length > 0">说明</span>
          <span class="btn-send" @click="seltGenre(2)" v-if="pickleName">发送</span>
          <span class="btn-subscribe" @click="seltGenre(1)" v-if="pickleName">订阅</span></div>
      </div>
      <p class="d_flex back_colorhuiDADADA" >
        <span>请点击“导出”按钮下载查看全部数据内容！</span>
        <span>最新更新时间：{{ myList.lastSyncTime }}</span>
      </p>
      <div style=";overflow: auto" :style="{'height': tableHeight + 'px'}">
        <table class="allTable" cellspacing="0">
          <thead>
            <tr>
              <th
                :key="indexF"
                v-for="(itemF, indexF) in myList.columns"
                style="text-align: left;"
              >{{ itemF }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="myList.datas.length === 0">
              <td :colspan="myList.columns.length">暂无数据</td>
            </tr>
            <tr v-if="myList.datas.length > 0" :key="index" v-for="(item, index) in myList.datas">
              <td :key="indexC" v-for="(itemC, indexC) in item" class="t_l">{{itemC}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- <div class="linDivR" v-if="mySerchData.length > 0">
      <div @click="clkModel(1)">
        <i class="icon iconfont icontiaojianguolv"></i>
        <p>搜索条件</p>
      </div>
      <div @click="clkModel(3)">
        <i class="icon iconfont iconbangzhu"></i>
        <p>说明</p>
      </div>
    </div> -->
    <!---->
    <modelRight
      ref="modelRight1"
      v-if="showModel"
      :title="title"
      :minWidth="'35%'"
      :onButton="1"
      :mlData="mlData"
      @sletModelId="sletModelId($event)"
      v-on:on-cancel="showModel = false"
      v-on:on-confirm="confSerch()"
      v-on:on-resetModel="resetSerch()"
    >
      <div class="dnlUl" style="height: 100%;overflow:auto">
        <ul>
          <li
            :class="parseInt(leftIndex) === parseInt(index) ? 'back_colorYellowfddfcf' : ''"
            :key="index"
            v-for="(item, index) in mySerchData"
            v-if="item.isMustFilter"
          >
            <span>{{ item.displayColumnName }}：</span>
            <div class="v_m">
              <allSelect
                @clickValue="getValueList(item)"
                v-if="parseInt(item.dataDicValueCount) <= 100 && item.fieldType !== 'Datetime'"
                :multiple="true"
                :showSerch="true"
                v-model="item.valueData"
                :chooseData="item.childList"
                :needReturn="'id'"
                :matchValue="'name'"
                :showValue="'{{name}}'"
                :width="'100%'"
                :placeholder="'全部'"
                :borderLine="'#E5E5E5'"
              ></allSelect>
              <div
                v-if="parseInt(item.dataDicValueCount) > 100 && item.fieldType !== 'Datetime'"
                class="dnlLeft NoWrap c_p"
                @click="seltModel(item, index)"
              >
                <p class="dis_line v_m" v-if="item.valueDataMd.length === 0">
                  <span style="color: rgb(125, 125, 125)">全部</span>
                </p>
                <p
                  class="dis_line v_m"
                  :key="leftIndex"
                  v-for="(leftItem, leftIndex) in item.valueDataMd"
                  v-if="item.valueDataMd.length > 0"
                >
                  <abbr v-if="leftIndex !== 0">,</abbr>
                  <span>{{ leftItem.name }}</span>
                </p>
              </div>
              <div class="d_flex" v-if="item.fieldType === 'Datetime'">
                <div style="width: 45%">
                  <cander v-model="item.startTime" :className="'allInput'" :newWidth="'100%'"></cander>
                </div>
                <div class="t_c" style="width: 40px">至</div>
                <div style="width: 45%">
                  <cander
                    :minDate="item.startTime"
                    v-model="item.endTime"
                    :className="'allInput'"
                    :newWidth="'100%'"
                    :isBear="true"
                  ></cander>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </modelRight>
    <modelRight
      v-if="showModel2"
      :title="title2"
      :minWidth="'50%'"
      :onButton="0"
      v-on:on-cancel="showModel2 = false"
    >
      <div style="height: 100%;overflow: auto;padding: 0 10px">
        <div class="m_b_10">
          <textarea
            v-model="mydbDescribe"
            rows="5"
            class="allTextarea"
            readonly
            style="width: calc(100% - 12px);background-color: transparent"
          ></textarea>
        </div>
        <div>
          <table class="allTable" cellspacing="0">
            <thead>
              <tr>
                <th style="text-align: left">名称</th>
                <th style="text-align: left">说明</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="index" v-for="(item, index) in myWideTableFilterList">
                <td style="text-align: left">{{ item.displayColumnName }}</td>
                <td style="text-align: left">{{ item.description }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </modelRight>
    <model
      v-if="showModel3"
      :title="title3"
      :minWidth="'60%'"
      :onButton="1"
      v-on:on-cancel="showModel3 = false"
      v-on:on-confirm="confirmSuCriber"
    >
      <div class="pd_10_20">
        <div class="dnlUl" style="max-height: 70vh;overflow: auto">
          <ul>
            <li>
              <span style="vertical-align: top">已选参数：</span>
              <div>
                <div class="dnlUl_par">
                  <p
                    :key="index"
                    v-for="(item, index) in subscriptionData.parameterJsonList"
                  >{{ item }}</p>
                </div>
              </div>
            </li>
            <li v-if="parseInt(isGenre) === 1">
              <span>订阅名称:</span>
              <div>
                <input
                  v-model="subscriptionData.subscribeName"
                  type="text"
                  class="allInput"
                  style="width: calc(100% - 12px)"
                />
              </div>
            </li>
            <li>
              <span style="vertical-align: top;margin-top: 5px">邮箱地址：</span>
              <div>
                <section class="dnlUl_emlS">
                  <input @input="seltEmail()" v-model="serchEamil" type="text" placeholder="请输入..." />
                  <div v-if="serchEamil !== ''">
                    <div v-if="allEmailList.length === 0">未找到任何结果</div>
                    <p
                      @click="pickEmail(item, 1)"
                      class="NoWrap"
                      :key="index"
                      v-for="(item, index) in allEmailList"
                    >{{ item }}</p>
                    <p
                      @click="pickEmail('', 2)"
                      class="NoWrap"
                      v-if="allEmailList.length === 0"
                    >{{ serchEamil }}</p>
                  </div>
                </section>
                <div class="dnlUl_eml">
                  <div :key="index" v-for="(item, index) in subscriptionData.subscribeEmails">
                    <span class="m_r_10">{{ item }}</span>
                    <i
                      @click="eraseEmail(index)"
                      class="icon iconfont iconguanbi colorYellowF36A20"
                    ></i>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <span>邮箱标题:</span>
              <div>
                <input
                  v-model="subscriptionData.subscribeTitle"
                  type="text"
                  class="allInput"
                  style="width: calc(100% - 12px)"
                />
              </div>
            </li>
            <li>
              <span>正文：</span>
              <div>
                <textarea
                  v-model="subscriptionData.subscribeBody"
                  rows="5"
                  class="allTextarea"
                  style="width: calc(100% - 12px)"
                ></textarea>
              </div>
            </li>
            <li>
              <span>文件类型：</span>
              <div class="v_m" style="width: 100px">
                <allSelect
                  v-model="subscriptionData.fileType"
                  :chooseData="subfileType"
                  :needReturn="'id'"
                  :matchValue="'name'"
                  :showValue="'{{name}}'"
                  :width="'100%'"
                  :placeholder="'全部'"
                  :borderLine="'#E5E5E5'"
                ></allSelect>
              </div>
            </li>
            <li v-if="parseInt(isGenre) === 1">
              <span>订阅周期：</span>
              <div>
                <input
                  v-model="subscriptionData.uploadFrequency"
                  value="EveryDay"
                  type="radio"
                  class="allRadio"
                  id="mdRadio1"
                  name="mdRadio"
                />
                <label for="mdRadio1"></label>
                <label for="mdRadio1">
                  <span class="m_l_5 m_r_20">每天</span>
                </label>
                <input
                  v-model="subscriptionData.uploadFrequency"
                  value="EveryWeek"
                  type="radio"
                  class="allRadio"
                  id="mdRadio2"
                  name="mdRadio"
                />
                <label for="mdRadio2"></label>
                <label for="mdRadio2">
                  <span class="m_l_5 m_r_20">每周</span>
                </label>
                <input
                  v-model="subscriptionData.uploadFrequency"
                  value="EveryMonth"
                  type="radio"
                  class="allRadio"
                  id="mdRadio3"
                  name="mdRadio"
                />
                <label for="mdRadio3"></label>
                <label for="mdRadio3">
                  <span class="m_l_5">每月</span>
                </label>
              </div>
            </li>
            <li v-if="parseInt(isGenre) === 1">
              <span style="margin-top: 7px">发送时间：</span>
              <div style="vertical-align: top">
                <!--每天-->
                <div v-if="subscriptionData.uploadFrequency === 'EveryDay'">
                  <div class="dis_line v_m" style="width: 60px">
                    <allSelect
                      v-model="subScriTime.fisthours"
                      :chooseData="$commonJs.returnHours(1)"
                      :needReturn="'id'"
                      :matchValue="'name'"
                      :showValue="'{{name}}'"
                      :width="'100%'"
                      :placeholder="'全部'"
                      :borderLine="'#E5E5E5'"
                    ></allSelect>
                  </div>
                  <div class="dis_line v_m t_c" style="width: 10px">:</div>
                  <div class="dis_line v_m" style="width: 60px">
                    <allSelect
                      v-model="subScriTime.lastMin"
                      :chooseData="$commonJs.returnHours(2)"
                      :needReturn="'id'"
                      :matchValue="'name'"
                      :showValue="'{{name}}'"
                      :width="'100%'"
                      :placeholder="'全部'"
                      :borderLine="'#E5E5E5'"
                    ></allSelect>
                  </div>
                </div>
                <!--每周-->
                <div v-if="subscriptionData.uploadFrequency === 'EveryWeek'">
                  <div class="dis_line v_m m_r_10" style="width: 100px">
                    <allSelect
                      v-model="subScriTime.weekTime"
                      :chooseData="weekList"
                      :multiple="true"
                      :needReturn="'id'"
                      :matchValue="'name'"
                      :showValue="'{{name}}'"
                      :width="'100%'"
                      :placeholder="'全部'"
                      :borderLine="'#E5E5E5'"
                    ></allSelect>
                  </div>
                  <div class="dis_line v_m" style="width: 60px">
                    <allSelect
                      v-model="subScriTime.weekHours"
                      :chooseData="$commonJs.returnHours(1)"
                      :needReturn="'id'"
                      :matchValue="'name'"
                      :showValue="'{{name}}'"
                      :width="'100%'"
                      :placeholder="'全部'"
                      :borderLine="'#E5E5E5'"
                    ></allSelect>
                  </div>
                  <div class="dis_line v_m t_c" style="width: 10px">:</div>
                  <div class="dis_line v_m" style="width: 60px">
                    <allSelect
                      v-model="subScriTime.weekMin"
                      :chooseData="$commonJs.returnHours(2)"
                      :needReturn="'id'"
                      :matchValue="'name'"
                      :showValue="'{{name}}'"
                      :width="'100%'"
                      :placeholder="'全部'"
                      :borderLine="'#E5E5E5'"
                    ></allSelect>
                  </div>
                </div>
                <!--每月-->
                <div v-if="subscriptionData.uploadFrequency === 'EveryMonth'">
                  <div class="m_b_10">
                    <input
                      v-model="subScriTime.isData"
                      :value="1"
                      type="radio"
                      class="allRadio"
                      id="muthRadio1"
                    />
                    <label for="muthRadio1"></label>
                    <div
                      class="d_flex m_l_5"
                      style="display: inline-flex;width: 270px"
                      v-if="parseInt(subScriTime.isTwo) === 1"
                    >
                      <div>第</div>
                      <div>
                        <input
                          v-model="subScriTime.fistDate"
                          type="number"
                          class="allInput"
                          style="width: 21px"
                          :disabled="parseInt(subScriTime.isData) === 2"
                        />
                      </div>
                      <div class="m_l_5">个工作日</div>
                      <div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect
                            v-model="subScriTime.monHours"
                            :chooseData="$commonJs.returnHours(1)"
                            :needReturn="'id'"
                            :matchValue="'name'"
                            :showValue="'{{name}}'"
                            :width="'100%'"
                            :placeholder="'全部'"
                            :borderLine="'#E5E5E5'"
                            :disabled="parseInt(subScriTime.isData) === 2"
                          ></allSelect>
                        </div>
                        <div class="dis_line v_m t_c" style="width: 10px">:</div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect
                            v-model="subScriTime.monMin"
                            :chooseData="$commonJs.returnHours(2)"
                            :needReturn="'id'"
                            :matchValue="'name'"
                            :showValue="'{{name}}'"
                            :width="'100%'"
                            :placeholder="'全部'"
                            :borderLine="'#E5E5E5'"
                            :disabled="parseInt(subScriTime.isData) === 2"
                          ></allSelect>
                        </div>
                      </div>
                      <div>
                        <i
                          @click="seltWeek(2)"
                          class="icon iconfont iconicon02 colorYellowF36A20"
                          v-if="parseInt(subScriTime.isData) === 1"
                        ></i>
                      </div>
                    </div>
                    <div
                      class="d_flex m_l_5"
                      style="display: inline-flex;width: 430px"
                      v-if="parseInt(subScriTime.isTwo) === 2"
                    >
                      <div>第</div>
                      <div>
                        <input
                          v-model="subScriTime.fistDate"
                          type="number"
                          class="allInput"
                          style="width: 21px"
                          :disabled="parseInt(subScriTime.isData) === 2"
                        />
                      </div>
                      <div class="m_l_5">个工作日</div>
                      <div class="m_r_5 colorYellowF36A20">
                        <i
                          @click="seltWeek(1)"
                          class="icon iconfont iconguanbi"
                          v-if="parseInt(subScriTime.isData) === 1"
                        ></i>
                        <span class="m_l_5">&</span>
                      </div>
                      <div>第</div>
                      <div>
                        <input
                          v-model="subScriTime.lastDate"
                          type="number"
                          class="allInput"
                          style="width: 21px"
                          :disabled="parseInt(subScriTime.isData) === 2"
                        />
                      </div>
                      <div class="m_l_5">个工作日</div>
                      <div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect
                            v-model="subScriTime.monHours"
                            :chooseData="$commonJs.returnHours(1)"
                            :needReturn="'id'"
                            :matchValue="'name'"
                            :showValue="'{{name}}'"
                            :width="'100%'"
                            :placeholder="'全部'"
                            :borderLine="'#E5E5E5'"
                            :disabled="parseInt(subScriTime.isData) === 2"
                          ></allSelect>
                        </div>
                        <div class="dis_line v_m t_c" style="width: 10px">:</div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect
                            v-model="subScriTime.monMin"
                            :chooseData="$commonJs.returnHours(2)"
                            :needReturn="'id'"
                            :matchValue="'name'"
                            :showValue="'{{name}}'"
                            :width="'100%'"
                            :placeholder="'全部'"
                            :borderLine="'#E5E5E5'"
                            :disabled="parseInt(subScriTime.isData) === 2"
                          ></allSelect>
                        </div>
                      </div>
                      <div>
                        <i
                          @click="seltWeek(1)"
                          class="icon iconfont iconguanbi colorYellowF36A20"
                          v-if="parseInt(subScriTime.isData) === 1"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div>
                    <input
                      v-model="subScriTime.isData"
                      :value="2"
                      type="radio"
                      class="allRadio"
                      id="muthRadio2"
                    />
                    <label for="muthRadio2"></label>
                    <div class="d_flex m_l_5" style="display: inline-flex;width: 215px">
                      <div>第</div>
                      <div>
                        <input
                          v-model="subScriTime.allData"
                          type="number"
                          class="allInput"
                          style="width: 21px"
                          :disabled="parseInt(subScriTime.isData) === 1"
                        />
                      </div>
                      <div class="m_l_5">天</div>
                      <div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect
                            v-model="subScriTime.monHoursTwo"
                            :chooseData="$commonJs.returnHours(1)"
                            :needReturn="'id'"
                            :matchValue="'name'"
                            :showValue="'{{name}}'"
                            :width="'100%'"
                            :placeholder="'全部'"
                            :borderLine="'#E5E5E5'"
                            :disabled="parseInt(subScriTime.isData) === 1"
                          ></allSelect>
                        </div>
                        <div class="dis_line v_m t_c" style="width: 10px">:</div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect
                            v-model="subScriTime.monMinTwo"
                            :chooseData="$commonJs.returnHours(2)"
                            :needReturn="'id'"
                            :matchValue="'name'"
                            :showValue="'{{name}}'"
                            :width="'100%'"
                            :placeholder="'全部'"
                            :borderLine="'#E5E5E5'"
                            :disabled="parseInt(subScriTime.isData) === 1"
                          ></allSelect>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </model>
    <model
      v-if="showModel4"
      :title="'正在下载'"
      :minWidth="'60%'"
      :showClose="1"
      :onButton="0"
      v-on:on-cancel="showModel3 = false"
    >
      <div class="pd_10_20">
        <div class="filrProgNum" style="margin: auto">
          <p class="d_flex">
            <span>{{ upName }}</span>
            <span class="colorGray9D9D9D">{{ uploadPercent }}%</span>
          </p>
          <div class="m_t_5 m_b_5">
            <div :style="{'width': uploadPercent + '%'}"></div>
          </div>
        </div>
      </div>
    </model>
    <model
      v-if="showNotify"
      :onButton="2"
      :title="''"
      :minWidth="'36%'"
      v-on:on-cancel="showNotify = false"
      v-on:on-confirm="showNotify = false"
    >
      <div style="padding: 30px 40px; text-align: center">
        <img src="../../../assets/model03.png" height="60" width="60" />
        <p style="font-size: 16px; font-weight: bold; margin: 20px;">{{ notifyInfo }}</p>
      </div>
    </model>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import avatar from '@/assets/loading.gif'
let timeInever
let timeout
let timeOutEml
export default {
  name: 'myDnloadHomeTwoDetail',
  components: {
    draggable
  },
  data () {
    return {
      isBtn: false,
      showModel4: false,
      uploadPercent: 0,
      upName: '',
      mySerchFist: {
        key1DisplayName: '',
        key2DisplayName: '',
        key1List: []
      },
      tableHeight: 1080,
      pickleList: [],
      storeList: [],
      pickleName: '',
      storeName: '',
      weekTime: '',
      fisthours: '',
      lastMin: '',
      formId: parseInt(this.$route.query.formChildTableId),
      myTableId: 0,
      showModel: false,
      title: {
        icon: '',
        name: '搜索条件'
      },
      showModel1: false,
      title1: {
        icon: 'icon iconfont iconcustomize',
        name: '自定义列'
      },
      showModel2: false,
      title2: {
        icon: '',
        name: '说明'
      },
      showModel3: false,
      title3: '',
      isGenre: 0,
      myList: {
        columns: [],
        datas: [],
        lastSyncTime: '',
        totalCount: 0
      },
      mydbDescribe: '',
      myWideTableFilterList: [], // 可选列
      mySerchList: [], // 搜索条件
      mySerchData: [], // 搜索右部
      mySelectedColumnList: [], // 已选列
      mySelectedColumnListTwo: [], // 已选列(未排序)
      seltFyear: '',
      seltFmouth: '',
      fileYear: [],
      fileMouth: [
        {
          id: '',
          name: '全部'
        }
      ],
      mlData: {
        isModelLeft: 0,
        topName: '',
        DbName: '',
        Dickey: '',
        isNeedPermissionControl: false,
        leftIdList: []
      },
      fileType: [
        {
          id: 1,
          name: 'excel'
        },
        {
          id: 2,
          name: 'csv'
        }
      ],
      weekList: [
        {
          id: '',
          name: '全部'
        },
        {
          id: 1,
          name: '周一'
        },
        {
          id: 2,
          name: '周二'
        },
        {
          id: 3,
          name: '周三'
        },
        {
          id: 4,
          name: '周四'
        },
        {
          id: 5,
          name: '周五'
        },
        {
          id: 6,
          name: '周六'
        },
        {
          id: 7,
          name: '周日'
        }
      ],
      unitList: [
        {
          id: 0,
          name: '元'
        },
        {
          id: 1,
          name: '千元'
        }
      ],
      unitSelected: 0,
      myFistColumnName: '',
      myColumnName: '',
      mydbName: '',
      leftIndex: 0,
      subscriptionData: {
        id: 0,
        subscribeName: '',
        subscribeEmails: [], // 邮箱
        subscribeTitle: '', // 标题
        subscribeBody: '', // 正文
        parameterJson: '', // 已选条件
        parameterJsonList: [],
        parameterJsonEn: [],
        tableId: 0,
        fileType: 1, // 文件类型 1 = excel, 2 = csv
        uploadFrequency: 'EveryDay', // EveryDay, EveryWeek, EveryMonth
        sendTime: ''
      },
      subScriTime: {
        weekTime: '',
        fisthours: '00',
        lastMin: '00',
        weekHours: '00',
        weekMin: '00',
        monHours: '00',
        monMin: '00',
        monHoursTwo: '00',
        monMinTwo: '00',
        fistDate: '',
        lastDate: '',
        allData: '',
        isData: 1,
        isTwo: 1
      },
      subfileType: [
        {
          id: 1,
          name: 'excel'
        },
        {
          id: 2,
          name: 'csv'
        }
      ],
      IsHasUnit: false,
      downName: '',
      progress: 0,
      serchEamil: '',
      allEmailList: [],
      dowFileName: '',
      myTabList: [],
      upFlage: 0,
      newHisId: 0,
      showNotify: false,
      notifyInfo: '',
      logId: 0
    }
  },
  created () {
    this.getAllNf()
    for (let i = 1; i < 13; i++) {
      let list = {
        id: i,
        name: i < 10 ? '0' + i : i
      }
      this.fileMouth.push(list)
    }
    if (this.formId && this.formId > 0) {
      this.getKeyValueMap()
    }
  },
  mounted () {
    this.tableHeight = window.innerHeight - 246 - document.getElementById('topSerchDiv').clientHeight
    timeout = setInterval(p => {
      this.tableHeight = window.innerHeight - 246 - document.getElementById('topSerchDiv').clientHeight
    }, 1000)
  },
  destroyed () {
    clearInterval(timeout)
  },
  methods: {
    // 根据搜索获取邮箱
    seltEmail () {
      clearTimeout(timeOutEml)
      timeOutEml = setTimeout(p => {
        this.getAllEmail()
      }, 1000)
    },
    pickEmail (item, type) {
      if (parseInt(type) === 1) {
        this.subscriptionData.subscribeEmails.push(item)
        this.allEmailList = []
        this.serchEamil = ''
      } else {
        if (this.$commonJs.returnDigit(this.serchEamil, 'email', '请输入正确的邮箱')) {
          this.serchEamil = ''
          return
        }
        this.subscriptionData.subscribeEmails.push(this.serchEamil)
        this.serchEamil = ''
      }
    },
    eraseEmail (index) {
      this.subscriptionData.subscribeEmails.splice(index, 1)
    },
    getAllEmail () {
      this.$axiox.get('/api/Role/SearchEmail?email=' + this.serchEamil, '', true).then(msg => {
        this.allEmailList = msg.data || []
      })
    },
    // 获取投放通道和店铺
    getKeyValueMap () {
      this.$axiox.get('/api/Download/GetKeyValueMap?wideid=' + this.formId).then(msg => {
        let chanlList = msg.data
        this.mySerchFist = {
          key1DisplayName: chanlList.key1DisplayName,
          key2DisplayName: chanlList.key2DisplayName,
          key1List: chanlList.key1
        }
        for (let i = 0; i < this.mySerchFist.key1List.length; i++) {
          this.$set(this.mySerchFist.key1List[i], 'clidList', [])
          for (let j = 0; j < chanlList.key2.length; j++) {
            if (this.mySerchFist.key1List[i].key1Name === chanlList.key2[j].key1Name) {
              this.$set(this.mySerchFist.key1List[i], 'clidList', chanlList.key2[j].key2Name)
            }
          }
        }
        console.log(this.mySerchFist)
        // let list = msg.data.shops || []
        // for (let i = 0; i < list.length; i++) {
        //   let data = {
        //     id: list[i].channelName,
        //     name: list[i].channelName,
        //     shopName: []
        //   }
        //   for (let j = 0; j < list[i].shopName.length; j++) {
        //     let object = {
        //       id: list[i].shopName[j],
        //       name: list[i].shopName[j]
        //     }
        //     data.shopName.push(object)
        //   }
        //   this.pickleList.push(data)
        // }
        // for (let i = 0; i < this.pickleList.length; i++) {
        //   for (let j = 0; j < chanlList.length; j++) {
        //     if (this.pickleList[i].name === chanlList[j].channelName) {
        //       this.$set(this.pickleList[i], 'childTableId', chanlList[j].childTableId)
        //       this.$set(this.pickleList[i], 'columnName', chanlList[j].columnName)
        //     }
        //   }
        // }
      })
    },
    seltPickle (e, type) {
      if (type === 1) {
        this.storeList = [
          {
            id: '',
            name: '全部'
          }
        ]
        console.log(e)
        this.myList = {
          columns: [],
          datas: [],
          lastSyncTime: '',
          totalCount: 0
        }
        this.storeName = ''
        this.myTableId = e.childTableId
        this.mydbName = e.key1Name
        this.myFistColumnName = e.key1ColumnName
        this.myColumnName = e.key2ColumnName
        for (let i = 0; i < e.clidList.length; i++) {
          let data = {
            id: e.clidList[i],
            name: e.clidList[i]
          }
          this.storeList.push(data)
        }
        this.getWideTableFilter(e.childTableId)
      } else {
        this.confSerch()
      }
    },
    // 获取宽表条件接口
    getWideTableFilter (id) {
      this.mySerchList = []
      this.mySerchData = []
      this.$axiox.get('/api/Download/GetWideTableFilter?tableid=' + id).then(msg => {
        this.myWideTableFilterList = msg.data || []
        this.mydbDescribe = msg.dbDescribe
        this.dowFileName = msg.fileName
        this.IsHasUnit = msg.isHasUnit
        this.unitSelected = msg.defaultUnit
        let serchList = []
        for (let i = 0; i < this.myWideTableFilterList.length; i++) {
          if (this.myWideTableFilterList[i].isMustFilter || this.myWideTableFilterList[i].isMustShow) {
            serchList.push(JSON.parse(JSON.stringify(this.myWideTableFilterList[i])))
            this.myTabList = JSON.parse(JSON.stringify(serchList))
          }
        }
        for (let i = 0; i < serchList.length; i++) {
          this.$set(serchList[i], 'valueData', '')
          this.$set(serchList[i], 'valueDataMd', [])
          this.$set(serchList[i], 'startTime', '')
          this.$set(serchList[i], 'endTime', '')
          this.$set(serchList[i], 'timeRangeType', '')
          this.$set(serchList[i], 'childList', [])
        }
        for (let i = 0; i < serchList.length; i++) {
          if (serchList[i].isAbove) {
            this.mySerchList.push(JSON.parse(JSON.stringify(serchList[i])))
          }
          if (!serchList[i].isAbove) {
            this.mySerchData.push(JSON.parse(JSON.stringify(serchList[i])))
          }
        }
        // if (this.pickleName !== '') {
        //   this.$nextTick(p => {
        //     this.confSerch()
        //   }, 100)
        // }
      })
    },
    checkMove () { },
    clkModel (type) {
      if (parseInt(type) === 1) {
        this.mlData.isModelLeft = 0
        this.showModel = true
        this.leftIndex = ''
      } else if (parseInt(type) === 2) {
        this.showModel1 = true
      } else if (parseInt(type) === 3) {
        this.showModel2 = true
      }
    },
    resetSerch () {
      for (let i = 0; i < this.mySerchData.length; i++) {
        this.mySerchData[i].valueData = ''
        this.mySerchData[i].startTime = ''
        this.mySerchData[i].endTime = ''
        this.mySerchData[i].valueDataMd = []
      }
    },
    confSerch () {
      let list = []
      if (this.myFistColumnName !== '') {
        let storeData = this.pickleName ? this.pickleName.split(',') : []
        let data = {
          fieldName: this.myFistColumnName,
          values: storeData,
          isShow: false,
          startTime: '',
          endTime: ''
          // timeRangeType: this.mySerchList[i].timeRangeType
        }
        list.push(data)
      }
      let storeData = this.storeName ? this.storeName.split(',') : []
      let data = {
        fieldName: this.myColumnName,
        values: storeData,
        isShow: false,
        startTime: '',
        endTime: ''
        // timeRangeType: this.mySerchList[i].timeRangeType
      }
      list.push(data)
      for (let i = 0; i < this.mySerchList.length; i++) {
        let data = {
          fieldName: this.mySerchList[i].columnName,
          values: [],
          isShow: false,
          startTime: this.mySerchList[i].startTime,
          endTime: this.mySerchList[i].endTime,
          order: this.mySerchList[i].order
          // timeRangeType: this.mySerchList[i].timeRangeType
        }
        list.push(data)
      }
      for (let i = 0; i < this.mySerchData.length; i++) {
        let allValue = []
        if (parseInt(this.mySerchData[i].dataDicValueCount) <= 100) {
          allValue = this.mySerchData[i].valueData ? this.mySerchData[i].valueData.split(',') : []
        }
        if (parseInt(this.mySerchData[i].dataDicValueCount) > 100) {
          allValue = this.mySerchData[i].valueDataMd.map(p => { return p.id }) || []
        }
        let data = {
          fieldName: this.mySerchData[i].columnName,
          values: allValue,
          isShow: false,
          startTime: this.mySerchData[i].startTime,
          endTime: this.mySerchData[i].endTime,
          order: this.mySerchData[i].order
          // timeRangeType: this.mySerchList[i].timeRangeType
        }
        list.push(data)
      }
      for (let i = 0; i < list.length; i++) {
        for (let j = i + 1; j < list.length; j++) {
          if (list[i].fieldName === list[j].fieldName) {
            list[j].endTime = list[i].endTime
            list[j].fieldName = list[i].fieldName
            list[j].isShow = list[i].isShow
            list[j].startTime = list[i].startTime
            list[j].values = list[i].values
            list[i].order = list[j].order
          }
        }
      }
      let newOb = {}
      list = list.reduce(function (p, msg) {
        if (!newOb[msg.fieldName]) {
          p.push(msg)
          newOb[msg.fieldName] = true
        }
        return p
      }, [])
      list = list.sort((a, b) => { return a.order - b.order })
      for (let i = 0; i < this.myTabList.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (this.myTabList[i].columnName === list[j].fieldName) {
            this.$set(list[j], 'isShow', this.myTabList[i].isMustShow)
          }
        }
      }
      this.$axiox.post('/api/Download/GetSampleDataByFilter?tableId=' + this.myTableId + '&unit=' + this.unitSelected, list).then(msg => {
        this.myList = {
          columns: msg.data.columns || [],
          datas: msg.data.datas || [],
          totalCount: msg.data.totalCount,
          lastSyncTime: msg.data.lastSyncTime
        }
      })
    },
    // 获取年份
    getAllNf () {
      let nowYear = new Date()
      this.fileYear = []
      let startYear = 2015
      let endYear = nowYear.getFullYear() + 1
      for (let i = startYear; i <= endYear; i++) {
        let list = {
          id: i,
          name: i
        }
        this.fileYear.push(list)
      }
      this.fileYear = this.fileYear.reverse()
    },
    getValueList (item) {
      console.log(item)
      this.mlData.isModelLeft = 0
      if (item.childList.length <= 1) {
        let data = {
          DbName: item.dataDicTableName,
          Dickey: item.dataDicKey || '',
          isNeedPermissionControl: item.isNeedPermissionControl,
          Keyword: '',
          TableId: this.myTableId,
          PageIndex: 1,
          PageSize: 100
        }
        let url = this.$commonJs.returnQuery('/api/Download/GetVauleByDicKey', data)
        item.childList = [
          {
            id: '',
            name: '全部'
          }
        ]
        this.$axiox.get(url).then(msg => {
          let list = msg.data.values || []
          for (let i = 0; i < list.length; i++) {
            let object = {
              id: list[i],
              name: list[i]
            }
            item.childList.push(object)
          }
        })
      }
    },
    seltModel (item, index) {
      this.mlData = {
        isModelLeft: 1,
        TableId: this.myTableId,
        topName: item.displayColumnName,
        DbName: item.dataDicTableName,
        isNeedPermissionControl: item.isNeedPermissionControl,
        Dickey: item.dataDicKey || '',
        leftIdList: item.valueDataMd || []
      }
      this.leftIndex = index
      this.$refs.modelRight1.emptyId()
      console.log(this.leftIndex)
    },
    sletModelId (e) {
      this.mySerchData[this.leftIndex].valueDataMd = JSON.parse(JSON.stringify(e))
      this.mlData.isModelLeft = 0
    },
    seltGenre (type) {
      this.isGenre = type
      this.subscriptionData = {
        id: 0,
        subscribeName: '',
        subscribeEmails: [], // 邮箱
        subscribeTitle: this.pickleName, // 标题
        subscribeBody: '', // 正文
        parameterJson: '', // 已选参数
        parameterJsonList: [],
        parameterJsonEn: [],
        tableId: this.myTableId,
        fileType: 1, // 文件类型 1 = excel, 2 = csv
        uploadFrequency: 'EveryDay', // EveryDay, EveryWeek, EveryMonth
        sendTime: ''
      }
      let list = [
        {
          displayColumnName: this.pickleName,
          fieldName: this.myColumnName,
          isShow: true,
          values: this.storeName ? this.storeName.split(',') : [],
          startTime: '',
          endTime: ''
        }
      ]
      let fistData = []
      for (let i = 0; i < this.mySerchList.length; i++) {
        let data = {
          displayColumnName: this.mySerchList[i].displayColumnName,
          fieldName: this.mySerchList[i].columnName,
          isShow: true,
          values: [],
          startTime: '',
          endTime: '',
          order: this.mySerchList[i].order
          // timeRangeType: this.mySerchList[i].timeRangeType
        }
        if (this.mySerchList[i].fieldType === 'Datetime') {
          data.startTime = this.mySerchList[i].startTime
          data.endTime = this.mySerchList[i].endTime
        }
        if (parseInt(this.mySerchList[i].dataDicValueCount) <= 100) {
          data.values = this.mySerchList[i].valueData ? this.mySerchList[i].valueData.split(',') : []
        }
        if (parseInt(this.mySerchList[i].dataDicValueCount) > 100) {
          data.values = this.mySerchList[i].valueDataMd.map(p => { return p.id }) || []
        }
        fistData.push(data)
      }
      list = list.concat(JSON.parse(JSON.stringify(fistData)))
      let lastList = []
      for (let i = 0; i < this.mySerchData.length; i++) {
        let data = {
          displayColumnName: this.mySerchData[i].displayColumnName,
          fieldName: this.mySerchData[i].columnName,
          isShow: true,
          values: [],
          startTime: '',
          endTime: '',
          order: this.mySerchData[i].order
          // timeRangeType: this.mySerchList[i].timeRangeType
        }
        if (this.mySerchData[i].fieldType === 'Datetime') {
          data.startTime = this.mySerchData[i].startTime
          data.endTime = this.mySerchData[i].endTime
        }
        if (parseInt(this.mySerchData[i].dataDicValueCount) <= 100) {
          data.values = this.mySerchData[i].valueData ? this.mySerchData[i].valueData.split(',') : []
        }
        if (parseInt(this.mySerchData[i].dataDicValueCount) > 100) {
          data.values = this.mySerchData[i].valueDataMd.map(p => { return p.id }) || []
        }
        lastList.push(data)
      }
      list = list.concat(JSON.parse(JSON.stringify(lastList)))
      // list = this.$commonJs.returnHeavy(list, 'fieldName')
      for (let i = 0; i < list.length; i++) {
        let fistNum = 0
        let subset = ''
        if (list[i].values.length > 0) {
          fistNum++
        }
        if (fistNum > 0) {
          subset = list[i].displayColumnName + '：' + list[i].values.join('、')
          this.subscriptionData.parameterJsonList.push(subset)
        }
        let lastNum = 0
        let data = ''
        if (list[i].startTime !== '' || list[i].endTime !== '') {
          lastNum++
        }
        if (lastNum > 0) {
          data = list[i].displayColumnName + '：' + list[i].startTime + '-' + list[i].endTime
          this.subscriptionData.parameterJsonList.push(data)
        }
      }
      for (let i = 0; i < list.length; i++) {
        for (let j = i + 1; j < list.length; j++) {
          if (list[i].fieldName === list[j].fieldName) {
            list[j].endTime = list[i].endTime
            list[j].fieldName = list[i].fieldName
            list[j].isShow = list[i].isShow
            list[j].startTime = list[i].startTime
            list[j].values = list[i].values
            list[i].order = list[j].order
          }
        }
      }
      list = list.sort((a, b) => { return a.order - b.order })
      list = this.$commonJs.returnHeavy(list, 'fieldName')
      this.subscriptionData.subscribeBody = this.subscriptionData.parameterJsonList.join('\n')
      this.subscriptionData.parameterJson = this.subscriptionData.parameterJsonList.join(',')
      this.subscriptionData.parameterJsonEn = JSON.parse(JSON.stringify(list))
      // console.log(this.subscriptionData)
      this.subScriTime = {
        weekTime: '',
        fisthours: '00',
        lastMin: '00',
        weekHours: '00',
        weekMin: '00',
        monHours: '00',
        monMin: '00',
        monHoursTwo: '00',
        monMinTwo: '00',
        fistDate: '',
        lastDate: '',
        allData: '',
        isData: 1,
        isTwo: 1
      }
      this.serchEamil = ''
      this.allEmailList = []
      if (parseInt(type) === 2) {
        this.title3 = '发送'
      } else {
        this.title3 = '订阅'
      }
      this.showModel3 = true
    },
    seltWeek (type) {
      this.subScriTime.isTwo = type
      this.subScriTime.fistDate = ''
      this.subScriTime.lastDate = ''
    },
    confirmSuCriber () {
      if (parseInt(this.isGenre) === 1 && this.subscriptionData.subscribeName === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请输入订阅名称',
          stayTime: 5
        })
        return
      }
      if (this.subscriptionData.subscribeEmails.length === 0) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请选择邮箱地址',
          stayTime: 5
        })
        return
      }
      if (this.subscriptionData.subscribeTitle === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请选择输入邮箱标题',
          stayTime: 5
        })
        return
      }
      if (this.subscriptionData.subscribeBody === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请选择输入正文',
          stayTime: 5
        })
        return
      }
      if (parseInt(this.isGenre) === 1) {
        if (this.subscriptionData.uploadFrequency === 'EveryDay') {
          this.subscriptionData.sendTime = this.subScriTime.fisthours + ':' + this.subScriTime.lastMin
        } else if (this.subscriptionData.uploadFrequency === 'EveryWeek') {
          let watt = this.subScriTime.weekTime !== '' ? this.subScriTime.weekTime : '1,2,3,4,5,6,7'
          this.subscriptionData.sendTime = watt + '/' + this.subScriTime.weekHours + ':' + this.subScriTime.weekMin
        } else if (this.subscriptionData.uploadFrequency === 'EveryMonth') {
          if (parseInt(this.subScriTime.isData) === 1) {
            let wday = this.subScriTime.lastDate !== '' ? this.subScriTime.fistDate + ',' + this.subScriTime.lastDate : this.subScriTime.fistDate
            this.subscriptionData.sendTime = wday + '个工作日/' + this.subScriTime.monHours + ':' + this.subScriTime.monMin
          } else {
            this.subscriptionData.sendTime = this.subScriTime.allData + '天/' + this.subScriTime.monHoursTwo + ':' + this.subScriTime.monMinTwo
          }
        }
        this.subscriptionData.fileName = this.pickleName
        this.$axiox.post('/api/Download/EditSubscribe', this.subscriptionData).then(msg => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '新增订阅成功',
            stayTime: 5
          })
          this.showModel3 = false
        })
      } else {
        // console.log(this.subscriptionData)
        let data = {
          sendName: '',
          sendTitle: this.subscriptionData.subscribeTitle,
          sendBody: this.subscriptionData.subscribeBody,
          sendEmails: JSON.parse(JSON.stringify(this.subscriptionData.subscribeEmails)),
          parameterJson: this.subscriptionData.parameterJson,
          tableId: this.subscriptionData.tableId,
          fileType: this.subscriptionData.fileType,
          parameterJsonEn: JSON.parse(JSON.stringify(this.subscriptionData.parameterJsonEn)),
          fileName: this.pickleName
        }
        this.$axiox.post('/api/Download/EditSendData', data).then(msg => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '发送成功',
            stayTime: 5
          })
          this.showModel3 = false
        })
      }
    },
    addDownloadLog (historyId, actionName, module) {
      let logInfo = {
        id: 0,
        historyId: historyId,
        actionName: actionName,
        module: module,
        remark: '',
        isSuccess: false
      }
      this.$axiox.post('/api/SystemLog/InsertDownloadSyncLog', logInfo).then(msg => {
        this.logId = msg.data || 0
      })
    },
    // 下载
    allUpdow (type) {
      this.coverGif()
      this.upFlage = 0
      this.isBtn = true
      setTimeout(p => {
        this.isBtn = false
      }, 2000)
      // let dis = type === 'excel' ? 'xlsx' : 'csv'
      // this.downName = this.dowFileName + '.' + dis
      // this.downName = this.pickleName + '-' + this.$commonJs.returnDate(this.$commonJs.todayDateTime, 'newYYMMDDSSFF') + '.' + dis
      let urldata = {
        tableId: this.myTableId,
        fileName: this.pickleName,
        format: type,
        unit: this.unitSelected
      }
      let list = []
      let storeData = this.storeName ? this.storeName.split(',') : []
      let data = {
        displayColumnName: this.mydbName,
        fieldName: this.myColumnName,
        values: storeData,
        isShow: false,
        startTime: '',
        endTime: ''
        // timeRangeType: this.mySerchList[i].timeRangeType
      }
      list.push(data)
      for (let i = 0; i < this.mySerchList.length; i++) {
        let data = {
          displayColumnName: this.mySerchList[i].displayColumnName,
          fieldName: this.mySerchList[i].columnName,
          values: [],
          isShow: false,
          startTime: this.mySerchList[i].startTime,
          endTime: this.mySerchList[i].endTime,
          order: this.mySerchList[i].order
          // timeRangeType: this.mySerchList[i].timeRangeType
        }
        list.push(data)
      }
      for (let i = 0; i < this.mySerchData.length; i++) {
        let allValue = []
        if (parseInt(this.mySerchData[i].dataDicValueCount) <= 100) {
          allValue = this.mySerchData[i].valueData ? this.mySerchData[i].valueData.split(',') : []
        }
        if (parseInt(this.mySerchData[i].dataDicValueCount) > 100) {
          allValue = this.mySerchData[i].valueDataMd.map(p => { return p.id }) || []
        }
        let data = {
          displayColumnName: this.mySerchData[i].displayColumnName,
          fieldName: this.mySerchData[i].columnName,
          values: allValue,
          isShow: false,
          startTime: this.mySerchData[i].startTime,
          endTime: this.mySerchData[i].endTime,
          order: this.mySerchData[i].order
          // timeRangeType: this.mySerchList[i].timeRangeType
        }
        list.push(data)
      }
      for (let i = 0; i < list.length; i++) {
        for (let j = i + 1; j < list.length; j++) {
          if (list[i].fieldName === list[j].fieldName) {
            list[j].endTime = list[i].endTime
            list[j].fieldName = list[i].fieldName
            list[j].isShow = list[i].isShow
            list[j].startTime = list[i].startTime
            list[j].values = list[i].values
            list[i].order = list[j].order
          }
        }
      }
      let newOb = {}
      list = list.reduce(function (p, msg) {
        if (!newOb[msg.fieldName]) {
          p.push(msg)
          newOb[msg.fieldName] = true
        }
        return p
      }, [])
      list = list.sort((a, b) => { return a.order - b.order })
      for (let i = 0; i < this.myTabList.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (this.myTabList[i].columnName === list[j].fieldName) {
            this.$set(list[j], 'isShow', this.myTabList[i].isMustShow)
          }
        }
      }
      let newName = []
      for (let i = 0; i < list.length; i++) {
        let fistNum = 0
        let subset = ''
        if (list[i].values.length > 0) {
          fistNum++
        }
        if (fistNum > 0) {
          subset = list[i].displayColumnName + '：' + list[i].values.join('、')
          newName.push(subset)
        }
        let lastNum = 0
        let data = ''
        if (list[i].startTime !== '' || list[i].endTime !== '') {
          lastNum++
        }
        if (lastNum > 0) {
          data = list[i].displayColumnName + '：' + list[i].startTime + '-' + list[i].endTime
          newName.push(data)
        }
      }
      let bodyData = {
        parameterjson: newName.join(','),
        parameterList: list
      }
      let url = this.$commonJs.returnQuery('/api/Download/DownLoadTableByFilter', urldata)
      this.$axiox.postTwo(url, bodyData).then(msg => {
        // console.log(msg)
        if (msg.data.isAboveMaxCount) {
          this.disCover()
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: msg.message,
            stayTime: 5
          })
        } else if (msg.data.isAsyncNotification) {
          this.disCover()
          // this.$commonJs.alertTips({
          //   type: 'success',
          //   title: '失败',
          //   content: msg.message,
          //   stayTime: 5
          // })
          this.notifyInfo = msg.message
          this.showNotify = true
        } else {
          // this.coverGif()
          clearInterval(timeInever)
          timeInever = setInterval(p => {
            // msg.data.hisId
            this.$axiox.getTwo('/api/Download/CheckDownLoadState?hisId=' + msg.data.hisId).then(p => {
              console.log(p)
              if (p.data === 'DataError') {
                this.disCover()
                clearInterval(timeInever)
                this.$commonJs.alertTips({
                  type: 'error',
                  title: '失败',
                  content: '下载异常',
                  stayTime: 5
                })
              } else if (p.data === 'Success') {
                // console.log(msg.data.hisId)
                // this.$commonJs.addDownloadLog(msg.data.hisId, '开始下载', '数据下载')
                this.addDownloadLog(msg.data.hisId, '开始下载', '数据下载')
                this.downName = p.message
                this.disCover()
                clearInterval(timeInever)
                this.upFlage = 1
                this.newHisId = msg.data.hisId
              }
            })
          }, 2000)
        }
      })
    },
    confirmExport (id) {
      clearInterval(timeInever)
      let that = this
      let url = ''
      that.uploadPercent = 0
      var xmlResquest = new XMLHttpRequest()
      url = this.$baseUrlConfig.baseUrl + '/api/Download/DownLoadFile?hisId=' + id
      xmlResquest.open('GET', url, true)
      xmlResquest.onprogress = function (e) {
        var percent = e.loaded / e.total
        that.uploadPercent = parseInt(percent * 100)// progress 在data中定义的全局变量，显示的进度
        // console.log(that.uploadPercent)
        that.upName = that.downName
        that.showModel4 = true
      }
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.localStorage.getItem('gskToken'))
      xmlResquest.setRequestHeader('Ocp-Apim-Subscription-Key', this.$baseUrlConfig.ocpKey)
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        if (content.type) {
          if (content.type.indexOf('json') >= 0) {
            that.$commonJs.updateDownloadLog(that.logId, id, '下载完成', '数据下载', false)
            that.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '暂无数据',
              stayTime: 5
            })
            that.showModel4 = false
            that.uploadPercent = 0
            return
          }
        }
        var elink = document.createElement('a')
        elink.download = that.downName
        elink.style.display = 'none'
        var blob = new Blob([content])
        if (that.$IENum === 11) {
          window.navigator.msSaveOrOpenBlob(blob, name + '.xls')
        } else {
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          document.body.removeChild(elink)
        }
        that.$commonJs.updateDownloadLog(that.logId, id, '下载完成', '数据下载', true)
        that.showModel4 = false
        that.uploadPercent = 0
      }
      xmlResquest.send()
    },
    // loading
    coverGif () {
      if (!document.getElementById('loadingGif')) {
        let dom = document.createElement('div')
        dom.id = 'loadingGif'
        let html = '<img src="' + avatar + '" height="144" width="192"/>'
        dom.innerHTML = html
        document.getElementById('app').appendChild(dom)
      }
    },
    disCover () {
      if (document.getElementById('loadingGif')) {
        document.getElementById('app').removeChild(document.getElementById('loadingGif'))
      }
    }
  },
  watch: {
    upFlage (value) {
      if (parseInt(value) !== 0) {
        this.confirmExport(this.newHisId)
      }
    },
    myTableId (v) {
      this.unitSelected = 0
    }

  }
}
</script>

<style scoped>
.btn-back{
  position:absolute;right:30px;top:40px;
}
.btn-group{
  display:flex;
  margin-bottom:10px;
}
.btn-group .total{
  font-size:18px;
}
.btn-group .btn-export{
  background: url(../../../assets/icons/icon-down.png) no-repeat;
  background-size:28px 28px ;
  width:28px;height:28px;
  margin-left:10px;
  display:inline-block;
  cursor:pointer;
}
.btn-group .btn-notice{
  background: url(../../../assets/icons/icon-dscp.png) no-repeat;
  background-size:16px 16px ;
  width:16px;height:16px;
  margin-right:20px;
  padding-left:20px;
  display:inline-block;
  cursor:pointer;
}
.btn-group .btn-send{
  width:40px;
  line-height:28px;
  background:#fff url(../../../assets/icons/icon-send.png) 5px center no-repeat;
  background-size:16px 16px ;
  margin-right:20px;
  padding-left:30px;
  display:inline-block;
  border-radius: 8px;
  border: 1px solid #ECECEC;
  cursor:pointer;
}
.btn-group .btn-subscribe{
  width:40px;
  line-height:28px;
  background:#fff url(../../../assets/icons/icon-bell.png) 5px center no-repeat;
  background-size:16px 16px ;
  margin-right:20px;
  padding-left:30px;
  display:inline-block;
  border-radius: 8px;
  border: 1px solid #ECECEC;
  cursor:pointer;
}
.btn-group .group-lf{margin-right:auto;}
.dnlDetDivTop {
  position: relative;
  vertical-align: middle;
}
.dnlDetDiv {
  display: none;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.15);
  width:50px;
  padding: 5px 0px;
  position: absolute;
  top: 25px;
  left: 0;
  right: 0;
  z-index: 10;
}
.dnlDetDivTop:hover .dnlDetDiv {
  display: block;
}
.dnlDetDiv > div {
  text-align: center;
  padding: 5px 0;
  cursor: pointer;
}
.dnlDetDiv > div > button {
  background-color: transparent;
  outline: none;
  border: none;
}
.dnlDetDiv > div > button:disabled {
  background-color: transparent !important;
  color: black !important;
}
.dnlDetDiv > div:hover {
  background-color: rgba(243, 106, 32, 0.2) !important;
}
.allTable th,
.allTable td {
  max-width: 480px !important;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.linDivR {
  position: fixed;
  top: 67px;
  right: 0;
  background: linear-gradient(103.31deg, #ff5022 4.44%, #fdcb2c 100%);
  border-radius: 8px 0px 0px 8px;
  padding: 10px 5px;
  color: white;
  text-align: center;
  z-index: 10;
}
.linDivR > div {
  cursor: pointer;
}
.linDivR > div:not(:last-child) {
  padding-bottom: 10px;
  border-bottom: 1px solid white;
}
.linDivR > div:not(:first-child) {
  padding-top: 10px;
}
.ribbonDiv {
  height: 100%;
}
.ribbonDiv > div > nav {
  margin-bottom: 10px;
}
.ribbonDiv > div {
  display: inline-block;
  vertical-align: top;
  width: 45%;
  height: calc(100% - 20px);
  padding: 10px;
}
.ribbonDiv > div > div {
  border: 1px solid #dadada;
  padding: 10px 10px 0 10px;
  height: calc(100% - 50px);
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/myDnload/myDnloadHomeTwoDetail.vue